
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import GoalSurveyModel from "./models/goal-survey.modes";
@Component({
  name: "goal-survey-statistics-item",
})
export default class GoalSurveyStatisticsItemComponent extends Vue {
  @Prop({ default: new GoalSurveyModel() }) data: GoalSurveyModel;

  get goalSurveyImage(): string {
    return this.$options.filters.goalSurveyImage(this.data.Id);    
  }

  get goalSurveyName(): string {
    return this.$options.filters.goalSurveyName(this.data.Id);
  }
}
